<script setup lang="ts">
import { computed } from 'vue'
import IconRefresh from '@/components/icons/IconRefresh.vue'

const props = defineProps<{
  pullDistance: number
  progress: number
  isRefreshing: boolean
  isDragging: boolean
}>()

const iconStyle = computed(() =>
  props.isRefreshing ? {} : { transform: `rotate(${props.progress * 180}deg)` }
)
</script>

<template>
  <div
    class="pull-to-refresh-indicator"
    :class="{ 'pull-to-refresh-indicator--dragging': isDragging }"
    :style="{ height: `${pullDistance}px` }"
  >
    <IconRefresh
      v-if="pullDistance > 0"
      class="icon"
      :class="{ 'icon--spinning': isRefreshing }"
      :style="iconStyle"
    />
  </div>
</template>

<style lang="scss" scoped>
.pull-to-refresh-indicator {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  margin-top: env(safe-area-inset-top, 0px);
  pointer-events: none;
  transition: height 200ms ease;
}

.pull-to-refresh-indicator--dragging {
  transition: none;
}

.icon {
  width: 1.25rem;
  height: 1.25rem;
  color: var(--purple200);
}

.icon--spinning {
  animation: spin 800ms linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
